import { store } from '@src/store';
import ClientDB from '@src/utils/clientDB';
import bc from '@src/utils/broadcastChannel';

export const logout = async () => {
  const udid = await ClientDB.Instance.getItem('deviceUdid');
  store.dispatch({ type: 'LOGOUT' });
  await ClientDB.Instance.clear();
  localStorage.clear();
  if (udid) {
    await ClientDB.Instance.setItem('deviceUdid', udid);
  }
  bc?.postMessage('reload');
  window.location = `${process.env.PUBLIC_URL}/auth/login`;
};
